// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Role } from "../../data/identity/role";
import { NodeDocument } from "./documents/node-document";
import { ItemEnvelope } from "./base/item-envelope";

export class NodeEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Node");
		if (jsonEnvelope) {
			this.Roles = jsonEnvelope.Roles;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public Roles: Role[] = [];
	public override Document: NodeDocument = new NodeDocument();
	public override get ItemId(): number { return this.Document.Item.NodeId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}